import React, { Component } from 'react'
import { Row, Col, Card, Form, Button, Container } from 'react-bootstrap';
import { Link } from "react-router-dom"
import './_home.scss';
import sendnotification from "../../../images/notifications.png";
import createstudent from "../../../images/student_login.png";
import createlecturer from "../../../images/lecturer_login.png";
// Images
import Addmission_Form from "../../../images/NewChangesDashBoardImages/Admission_Form.png"
import Addmission_List from "../../../images/NewChangesDashBoardImages/Admsiion_List.png"
import Student_Attendance_Report from "../../../images/NewChangesDashBoardImages/attendance_Report.png";
import scheduledquiz from '../../../images/NewChangesDashBoardImages/Quiz.png';
import monitorstudent from "../../../images/NewChangesDashBoardImages/student_profile.png";
import viewtest from "../../../images/NewChangesDashBoardImages/test_report.png";
import Exam_Marks_Update from "../../../images/NewChangesDashBoardImages/offline_exam_marks_reports.png";
import Offline_Exam_Reports from "../../../images/NewChangesDashBoardImages/Student_Perfamance_Report.png"
import scheduled from '../../../images/NewChangesDashBoardImages/exam_creation.png';
import Leadmangement from '../../../images/lead_m.png'

class Dashboard extends Component {
    render() {
        let moduleRestrictions = ''

        if (JSON.parse(localStorage.getItem("moduleRestrictions")) != undefined && JSON.parse(localStorage.getItem("moduleRestrictions")) != "") {
            moduleRestrictions = JSON.parse(localStorage.getItem("moduleRestrictions"))
        }
        console.log("fff", moduleRestrictions);
        return (
            <>
                <div className="home_section">
                    <Container fluid>
                        <Row>
                            {/* {
                                moduleRestrictions.Student_Profile != undefined && moduleRestrictions.Student_Profile == false ?
                                    (
                                        <Col sm={4}>
                                            <Card className="card-mains ">
                                                <Card.Body>
                                                    <Row>
                                                        <Col sm={8}>
                                                            <Card.Title className="title-2 scheduledtest-1 color_213046">Student Profile</Card.Title>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Card.Img variant="top" src={monitorstudent} className="scheduledtest-imgs-1" />
                                                        </Col>
                                                    </Row>
                                                    <Card.Text className="mt-4 font-16 color_4C6487">
                                                        View your students' complete profile here
                                                    </Card.Text>
                                                    <Link to={{
                                                        pathname: '/monitor/dashboard',
                                                        examtype: "Monitor"
                                                    }}>
                                                        <Button variant="outline-" className=" w-100 mt-3_2 view_Profile_Button">
                                                            View Profiles
                                                        </Button>
                                                    </Link>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )
                                    :
                                    ("")
                            } */}


                            {
                                moduleRestrictions.Exam_Made_Easy != undefined && moduleRestrictions.Exam_Made_Easy == false ?
                                    (
                                        <Col sm={4}>
                                            <Card className="card-mains mt-4">
                                                <Card.Body>
                                                    <Row>
                                                        <Col sm={8}>
                                                            <Card.Title className="title-2 scheduledtest-1 color_213046">Exam Creation</Card.Title>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Card.Img variant="top" src={scheduled} className="scheduledtest-imgs-1" />
                                                        </Col>
                                                    </Row>
                                                    <Card.Text className="mt-2 font-16 color_4C6487">
                                                        Schedule tests with custom Syllabus to students in latest Patterns. Auto generate Or Manually pick questions for tests
                                                    </Card.Text>
                                                    <Link to="exam_made_easy" >
                                                        <Button variant="outline-" className="scheduledtest-btn-1 w-100 mt-2">
                                                            Schedule Exam
                                                        </Button>
                                                    </Link>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )
                                    :
                                    ("")
                            }

                            {
                                moduleRestrictions.Lead_management != undefined && moduleRestrictions.Lead_management == false ?
                                    (
                                        <Col sm={4}>
                                            <Card className="card-mains ">
                                                <Card.Body>
                                                    <Row>
                                                        <Col sm={8}>
                                                            <Card.Title className="title-2 scheduledtest-1 color_213046">Lead management</Card.Title>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Card.Img variant="top" src={Leadmangement} className="scheduledtest-imgs-1" />
                                                        </Col>
                                                    </Row>
                                                    <Card.Text className="mt-4 font-16 color_4C6487">
                                                        Automate, Track & Control Your Entire Lead Journey on Lead Management
                                                    </Card.Text>
                                                    <Link to={{
                                                        pathname: '/lead-management-home',
                                                        examtype: "Monitor"
                                                    }}>
                                                        <Button variant="outline-" className=" w-100 mt-3_2 view_Profile_Button">
                                                            Lead management
                                                        </Button>
                                                    </Link>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )
                                    :
                                    ("")
                            }





                            {
                                moduleRestrictions.Quiz != undefined && moduleRestrictions.Quiz == false ?
                                    (
                                        <Col sm={4}>
                                            <Card className="card-mains mt-4">
                                                <Card.Body>
                                                    <Row>
                                                        <Col sm={8}>
                                                            <Card.Title className="title-2 scheduledtest-1 color_213046">Quiz Creation</Card.Title>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Card.Img variant="top" src={scheduledquiz} className="scheduledtest-imgs-1" />
                                                        </Col>
                                                    </Row>
                                                    <Card.Text className="mt-4 font-16 color_4C6487">
                                                        Schedule 15 mins and 30 mins Pop Quizzes during lectures instantly
                                                    </Card.Text>
                                                    <Link to="quiz_section" >
                                                        <Button variant="outline-" className="scheduledtest-btn-1 w-100 mt-4_3" >
                                                            Schedule Quiz
                                                        </Button>
                                                    </Link>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )
                                    :
                                    ("")
                            }


                            {
                                moduleRestrictions.View_Results != undefined && moduleRestrictions.View_Results == false ?
                                    (
                                        <Col sm={4}>
                                            <Card className="card-mains mt-4">
                                                <Card.Body>
                                                    <Row>
                                                        <Col sm={8}>
                                                            <Card.Title className="title-2 scheduledtest-1 color_213046">View Test Results</Card.Title>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Card.Img variant="top" src={viewtest} className="scheduledtest-imgs-1" />
                                                        </Col>
                                                    </Row>
                                                    <Card.Text className="mt-4 font-16 color_4C6487">
                                                        Generate Result Summary report of Students in a class and section of any test
                                                    </Card.Text>
                                                    <Link to={{
                                                        pathname: '/ExamReport',
                                                        examtype: "Results"
                                                    }}>
                                                        <Button variant="outline-" className="scheduledtest-btn-1 w-100 mt-4" >
                                                            View Test Results
                                                        </Button>

                                                    </Link>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )
                                    :
                                    ("")
                            }

                            {/* admission_form */}

                            {
                                moduleRestrictions.admission_form != undefined && moduleRestrictions.admission_form == false ?
                                    (
                                        <Col sm={4}>
                                            <Card className="card-mains mt-4">
                                                <Card.Body>
                                                    <Row>
                                                        <Col sm={8}>
                                                            <Card.Title className="title-2 scheduledtest-1 color_213046">Admission Form</Card.Title>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Card.Img variant="top" src={Addmission_Form} className="scheduledtest-imgs-1" />
                                                        </Col>
                                                    </Row>
                                                    <Card.Text className="mt-2 font-16 color_4C6487">
                                                        Enroll and admit your new students here.
                                                    </Card.Text>
                                                    <Link to="/admission-forms">
                                                        <Button variant="outline-" className="scheduledtest-btn-1 w-100 mt-3_2 mt-4">
                                                            Enroll Now
                                                        </Button>
                                                    </Link>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )
                                    :
                                    ("")
                            }



                            {/* admission_form_list */}
                            {
                                moduleRestrictions.admission_form_list != undefined && moduleRestrictions.admission_form_list == false ?
                                    (
                                        <Col sm={4}>
                                            <Card className="card-mains mt-4">
                                                <Card.Body>
                                                    <Row>
                                                        <Col sm={8}>
                                                            <Card.Title className="title-2 scheduledtest-1 color_213046">Enrolled Students</Card.Title>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Card.Img variant="top" src={Addmission_List} className="scheduledtest-imgs-1" />
                                                        </Col>
                                                    </Row>
                                                    <Card.Text className="mt-4 font-16 color_4C6487">
                                                        View your enrolled students here
                                                    </Card.Text>
                                                    <Link to="/student-admission-list">
                                                        <Button variant="outline-" className="scheduledtest-btn-1 w-100 mt-3_2">
                                                            View Students
                                                        </Button>
                                                    </Link>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )
                                    :
                                    ("")
                            }

                            {/* Student_Attendance_report */}

                            {
                                moduleRestrictions.Student_Attendance_report != undefined && moduleRestrictions.Student_Attendance_report == false ?
                                    (
                                        <Col sm={4}>
                                            <Card className="card-mains mt-4">
                                                <Card.Body>
                                                    <Row>
                                                        <Col sm={8}>
                                                            <Card.Title className="title-2 scheduledtest-1 color_213046"> Student Attendance Report</Card.Title>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Card.Img variant="top" src={Student_Attendance_Report} className="scheduledtest-imgs-1" />
                                                        </Col>
                                                    </Row>
                                                    <Card.Text className="mt-4 font-16 color_4C6487">
                                                        <p className=''>View your students' attendance reports here</p>
                                                    </Card.Text>
                                                    <Link to="/student/attendance-report">
                                                        <Button variant="outline-" className="scheduledtest-btn-1 w-100 mt-4">
                                                            View Attendance
                                                        </Button>
                                                    </Link>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )
                                    :
                                    ("")
                            }

                            {/* offline_marks_uploading */}

                            {
                                moduleRestrictions.offline_marks_uploading != undefined && moduleRestrictions.offline_marks_uploading == false ?
                                    (
                                        <Col sm={4}>
                                            <Card className="card-mains mt-4">
                                                <Card.Body>
                                                    <Row>
                                                        <Col sm={8}>
                                                            <Card.Title className="title-2 scheduledtest-1 font-18 color_213046">Offline Exam Marks Upload</Card.Title>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Card.Img variant="top" src={Exam_Marks_Update} className="scheduledtest-imgs-1" />
                                                        </Col>
                                                    </Row>
                                                    <Card.Text className="mt-4 font-16 color_4C6487">
                                                        Update the offline exam marks for your student here
                                                    </Card.Text>
                                                    <Link to="/student/marks-upload">
                                                        <Button variant="outline-" className="scheduledtest-btn-1 w-100 mt-4">
                                                            Upload Now
                                                        </Button>
                                                    </Link>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )
                                    :
                                    ("")
                            }


                            {/* offline_marks_Results */}

                            {
                                moduleRestrictions.offline_marks_Results != undefined && moduleRestrictions.offline_marks_Results == false ?
                                    (
                                        <Col sm={4}>
                                            <Card className="card-mains mt-4">
                                                <Card.Body>
                                                    <Row>
                                                        <Col sm={9}>
                                                            <Card.Title className="title-2 scheduledtest-1 font-18 color_213046">Offline Exam Performance Report</Card.Title>
                                                        </Col>
                                                        <Col sm={3}>
                                                            <Card.Img variant="top" src={Offline_Exam_Reports} className="scheduledtest-imgs-1" />
                                                        </Col>
                                                    </Row>
                                                    <Card.Text className="mt-4 font-16 color_4C6487">
                                                        View your students' offline exam performance here
                                                    </Card.Text>
                                                    <Link to="student/offline-exam-results">
                                                        <Button variant="outline-" className="scheduledtest-btn-1 w-100 mt-1">
                                                            View Now
                                                        </Button>
                                                    </Link>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )
                                    :
                                    ("")
                            }
                        </Row>
                    </Container>
                </div>
            </>
        )
    }

}
export default Dashboard;